import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import RadialGradient from '@bubble-ui/primitive-radial-gradient';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationBankError = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationBankError',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_6717_1767)",
    d: "M79.16 34.845H19.97v34.06h59.19v-34.06Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#4D6E9E",
    d: "M56.66 34.845H42.48v34.06h14.18v-34.06ZM86.7 34.845H75.36v34.06H86.7v-34.06ZM24.27 34.845H12.93v34.06h11.34v-34.06Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_6717_1767)",
    d: "M55.04 34.845H44.09v34.06h10.95v-34.06Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_6717_1767)",
    d: "M22.84 34.845H11.43v34.06h11.41v-34.06Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_6717_1767)",
    d: "M87.7 34.845H76.8v34.06h10.9v-34.06Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#698BD1",
    d: "M44.1 35.115h10.93v7.91s-1.28-2.89-3.45-4.81c-2.32-2.03-7.48-3.1-7.48-3.1ZM11.43 35.115h11.39v7.91s-1.34-2.89-3.6-4.81c-2.41-2.03-7.79-3.1-7.79-3.1ZM76.81 35.115h10.88v7.91s-1.28-2.89-3.44-4.81c-2.3-2.03-7.44-3.1-7.44-3.1Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_6717_1767)",
    fillRule: "evenodd",
    d: "M45.61.855 6.55 22.095c-2.13.93-3.47 2.83-3.48 4.9-.02 4.48 4.15 8.13 9.3 8.13h74.8c5.14 0 9.3-3.62 9.3-8.1v-.01c0-2.08-1.35-3.98-3.48-4.92L53.88.855c-2.6-1.14-5.67-1.14-8.27 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint5_linear_6717_1767)",
    fillRule: "evenodd",
    d: "M100 91.295H0v-7.89c0-1.9 1.54-3.44 3.44-3.44h93.11c1.9 0 3.44 1.54 3.44 3.44v7.89h.01Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint6_linear_6717_1767)",
    fillRule: "evenodd",
    d: "M93.95 79.965H5.55v-7.89c0-1.9 1.54-3.44 3.44-3.44H90.5c1.9 0 3.44 1.54 3.44 3.44v7.89h.01Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#698BD1",
    fillRule: "evenodd",
    d: "m49.98 15.255-17.08 8.49c-.76.35-1.6.53-2.46.52l-6.66-.04c-.96-.01-1.31-1.1-.5-1.54l23.75-12.89c1.82-.99 4.13-.98 5.94.02l23.37 12.89c.81.45.45 1.53-.51 1.53h-2.96c-.92 0-1.82-.21-2.62-.62l-15.15-8.26c-1.57-.8-3.51-.84-5.12-.1Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint7_radial_6717_1767)",
    fillRule: "evenodd",
    d: "M50 52c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24c0-13.26-10.75-24-24-24Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M46.14 87.01c0-2.12 1.6-3.72 3.72-3.72s3.72 1.6 3.72 3.72-1.6 3.72-3.72 3.72-3.72-1.6-3.72-3.72Zm1.36-6.84-.72-17.76h6.16l-.72 17.76H47.5Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_6717_1767",
    x1: 64.343,
    x2: 34.798,
    y1: 77.462,
    y2: 26.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.998,
    stopColor: "#5CE0FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_6717_1767",
    x1: 30.658,
    x2: 58.294,
    y1: 29.346,
    y2: 62.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.955,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_6717_1767",
    x1: 5.482,
    x2: 28.785,
    y1: 45.147,
    y2: 58.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.035,
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.918,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_6717_1767",
    x1: 63.362,
    x2: 90.975,
    y1: 29.365,
    y2: 62.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.955,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_6717_1767",
    x1: 39.313,
    x2: 57.574,
    y1: -1.496,
    y2: 48.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.102,
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.973,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint5_linear_6717_1767",
    x1: 42.299,
    x2: 53.2,
    y1: 58.385,
    y2: 99.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.035,
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.322,
    stopColor: "#82B4FA"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.708,
    stopColor: "#4E73F8"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.89,
    stopColor: "#3959F7"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint6_linear_6717_1767",
    x1: 45.937,
    x2: 51.258,
    y1: 54.255,
    y2: 84.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.035,
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.921,
    stopColor: "#3959F7"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint7_radial_6717_1767",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(55.717 72.55) scale(29.5917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FF8E45"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.483,
    stopColor: "#FA7C51"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F46362"
  }))));
};
ColoredIllustrationBankError.displayName = 'ColoredIllustrationBankError';
export default withProvisionalOverrideFromContext(ColoredIllustrationBankError);
//# sourceMappingURL=index.js.map